import { render, staticRenderFns } from "./Section6th.vue?vue&type=template&id=1684bec2&scoped=true&"
import script from "./Section6th.vue?vue&type=script&lang=js&"
export * from "./Section6th.vue?vue&type=script&lang=js&"
import style0 from "./Section6th.vue?vue&type=style&index=0&id=1684bec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684bec2",
  null
  
)

export default component.exports